'use client';

import { Chart, Colors } from 'chart.js';
import { useTheme } from 'next-themes';
import { UseThemeProps } from 'next-themes/dist/types';
import { useEffect } from 'react';

Chart.register(Colors);

export function TableConfig(): JSX.Element {
	useChartTheme();
	return <></>;
}

export function useChartTheme(): UseThemeProps {
	const response = useTheme();

	useEffect(() => {
		if (response.resolvedTheme === 'light') {
			// Chart.defaults.backgroundColor = '#9BD0F5';
			Chart.defaults.borderColor = '#DDDDDD';
			Chart.defaults.color = '#000000';
		} else {
			// Chart.defaults.backgroundColor = '#9BD0F5';
			Chart.defaults.borderColor = '#444444';
			Chart.defaults.color = '#FFFFFF';
		}
	}, [response.resolvedTheme]);

	return response;
}
// export function chartOptions<TType extends ChartType>(options: ChartOptions<TType>) {
// 	options.color
// }
